import { globalBreak } from "@/styles/break";
import { SxProps } from "@mui/material";

const footerPaymentMethodsAndLogosStyles:SxProps = {
    py:2,
	display: globalBreak({mobile:'grid', desktop:'flex'}),
    gridTemplateColumns:'repeat(2, 1fr)',
    rowGap:2,
	justifyContent:'space-between',
	alignItems:'flex-start',
    
	'& .footer-payment-methods-header':{
		fontFamily:'mikado-bold',
		mb:1,
		display:'block'
	},
    '& .footer-payment-methods':{
        gridColumn:'1 / -1',
        '& .footer-payment-method-logos':{
            display:'flex',
            alignItems:'center',
            columnGap:0.25,
            '& img':{
                height:24
            },
            '& a:focus-visible':{
                outlineOffset:0
            }
        }
    },
    '& .footer-logos-container':{
        '& .footer-logos':{
            display: 'flex',
            
            alignItems:'center',
            columnGap:1,
            '& .footer-logo-thuiswinkel':{
                height: globalBreak({mobile:'0.8em',desktop:'1.2em'})
            },
            '& .footer-logo-abn_best_winkel, & .footer-logo-abn_webshop':{
                height:globalBreak({mobile:'2em',desktop:'2.5em'})
            },
            '& .footer-logo-gecertificeerd':{
                height: globalBreak({mobile:'1.5em',desktop:'2em'}),
                mt:'4px'
            }
        }
    },
    '& .footer-trusted-widget > div':{
        mt:'15px !important'
    }
    
}

export const footerPaymentsContainerSX: SxProps = {
    '& .footer-payments-and-privacy-container': {
        '& .footer-payment-methods-and-logos': footerPaymentMethodsAndLogosStyles
    }
};